import React, { FC, useCallback, useState } from 'react';
import useOpenCloseToggle from 'src/common/hooks/useOpenCloseToggle';
import SimpleBoatListingItem from 'src/calendar/components/SyncCalendarPage/components/SimpleBoatListingItem';
import ListingSelectorModal from 'src/calendar/components/SyncCalendarPage/components/ListingSelectorModal';
import Button from 'src/common/components/Button';
import Icon from 'src/common/components/IconDS22';
import { FullBoatDetail } from 'src/types/boat/BoatDetail';
import s from './ListingSyncSelector.module.scss';

type SyncSelectorProps = {
  list: FullBoatDetail[];
  addIntegration: (boatId: string) => void;
};
const ListingSyncSelector: FC<SyncSelectorProps> = ({ list, addIntegration }) => {
  const { isOpen, open, close } = useOpenCloseToggle(false);
  const [selectedBoatId, setSelectedBoatId] = useState<string>(list[0]?.id);
  const [loading, setLoading] = useState(false);

  const selectedBoat = list.find(boat => boat.id === selectedBoatId) || list[0];

  const syncCalendar = useCallback(async () => {
    if (!selectedBoat) return;
    setLoading(true);
    await addIntegration(selectedBoat.id);
    setLoading(false);
  }, [addIntegration, selectedBoat]);

  if (!list.length) {
    return <div className={s.panel}>No boats found</div>;
  }

  return (
    <>
      <div className={s.panel}>
        <div className={s.headingContainer}>
          <div className={s.heading}>Select listing</div>
          <SimpleBoatListingItem
            key={selectedBoat?.id}
            photoUrl={selectedBoat?.photo_url}
            headline={selectedBoat?.headline}
            onClick={open}
          >
            <Icon id="caret-right" />
          </SimpleBoatListingItem>
        </div>
        <p className={s.description}>
          Choose a boat to link with Google Calendar. We’ll create a new calendar for you,
          named after your boat, and automatically sync it with your Getmyboat calendar.
        </p>
        <Button
          classNameModifier="noMargin"
          type="submit"
          onClick={syncCalendar}
          submitting={loading}
        >
          Create Synced Calendar
        </Button>
      </div>
      <ListingSelectorModal
        close={close}
        isOpen={isOpen}
        list={list}
        initialBoatId={selectedBoat.id}
        updateSelectedBoat={(boatId) => setSelectedBoatId(boatId)}
      />
    </>
  );
};

export default ListingSyncSelector;
